import React from 'react';
import './App.css';  // <-- Make sure this line is here
import AssignmentTracker from './components/AssignmentTracker';

function App() {
  return (
    <div className="App">
      <AssignmentTracker />
    </div>
  );
}

export default App;
